import { FC, memo } from 'react'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import Refresh from '@/assets/images/refresh.png'
import { Button, Popover, Spin } from 'antd'
import { ReactComponent as Help } from '@/assets/icons/help.svg'
import { useGetCurrentFlowData } from '@/hooks/analyze'
import { toThousands } from '@/utils/number'

interface OverViewProps {
  UTC: number
}
const Overview: FC<OverViewProps> = ({ UTC }) => {
  const { t } = useTranslation()

  const { inflowUsd, outflowUsd, netInflowUsd, inflowNum, outflowNum, setRefreshDep, isDisable } =
    useGetCurrentFlowData(UTC)

  const popoverContent = (
    <div className={styles.popoverContainer}>
      <div className={styles.title}>{t('analyze.illustrate')}</div>
      <div className={styles.content}>
        <div>{t('analyze.illustrateText1')}</div>
        <div>{t('analyze.illustrateText2')}</div>
        <div>{t('analyze.illustrateText3')}</div>
        <div>{t('analyze.illustrateText4')}</div>
        <div>{t('analyze.illustrateText5')}</div>
      </div>
    </div>
  )

  const handleRefresh = () => {
    setRefreshDep(new Date().getTime())
  }
  return (
    <div>
      <div className={styles.title}>
        {t('analyze.todayNumber')}
        <Button className={styles.refresh} onClick={handleRefresh} type="link" disabled={isDisable}>
          <img src={Refresh} style={{ width: '14px', height: '14px' }} alt=""></img>
          <span style={{ marginLeft: '5px', color: '#12B89A', fontSize: '14px' }}>
            {t('common.refresh')}
          </span>
        </Button>
      </div>

      <>
        {isDisable ? (
          <Spin>
            <div className={styles.container}></div>
          </Spin>
        ) : (
          <>
            <div className={styles.container}>
              <div className={styles.totalCard}>
                <h3>{t('analyze.inflow')}</h3>
                <p>{inflowUsd || 0}</p>
              </div>
              <div className={styles.totalCard}>
                <h3>{t('analyze.outflow')}</h3>
                <p>{outflowUsd || 0}</p>
              </div>
              <div className={styles.totalCard}>
                <h3>{t('analyze.netInflow')}</h3>
                <p>{netInflowUsd || 0}</p>
              </div>
              <div className={styles.NumberCard}>
                <h3>{t('analyze.inflowNumber')}</h3>
                <p>{toThousands(inflowNum || 0)}</p>
              </div>
              <div className={styles.NumberCard}>
                <div className={styles.info}>
                  <Popover content={popoverContent}>
                    <Help />
                  </Popover>
                </div>
                <h3>{t('analyze.outflowNumber')}</h3>
                <p>{toThousands(outflowNum || 0)}</p>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  )
}

export default memo(Overview)
